<template>
  <div
    class="lg:flex md:flex gap-5 lg:pt-20 md:pt-20 pt-5 lg:px-20 md:px-20 px-5 custflexdirec"
  >
    <div class="lg:w-1/2 md:w-1/2">
      <img
        src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/1.jpg"
        class="w-full custborderradius md:block lg:block"
        alt="swiper-img"
      />
    </div>
    <div class="lg:w-1/2 md:w-1/2">
      <p
        class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
      >
        About
      </p>

      <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
        The HeArt of Care is an International Alliance of organisations united
        in their efforts to promote awareness of the vital role played by
        Caregivers in our communities. Caregiver Saathi is proud to present this
        endeavour to our Caregiver community. With The HeArt of Care project, we
        aim to pay tribute to those who selflessly care for others, and we
        warmly invite Caregivers to share their art in the form of photographs,
        poetry and videos with us. We hope to capture the essence of care and
        instill a fresh perspective on the dignity, compassion, and joy of
        caregiving. These contributions will serve as a testament to the
        complexities of caregiving and inspire a broader appreciation for the
        remarkable resilience and commitment of Caregivers.
        <!-- <br />
            To gain inspiration and insights into our collaborative endeavours,
            we encourage you to explore the Gallery page. We believe that the
            images, poetry, and videos will ignite your creativity and provide
            valuable ideas for the images you may consider submitting. Please
            use the Share Your Work page to upload your artwork/image/poetry and
            help us foster greater awareness of Caregiver’s significance in
            society. -->

        <span
          v-b-modal.modal-1
          class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
          @click="handleClick('about')"
          >Know More</span
        >
      </p>
      <div class="flex lg:pt-8 md:pt-8 mob-hidden" v-b-modal.modal-1>
        <base-button
          type="primary"
          class="btntext px-4 py-1"
          @click="handleClick('about')"
          >Know More</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style>
@media (max-width: 640px) {
  .aboutimg {
    top: 416px;
    width: 343px;
    left: 1rem;
  }
  .custflexdirec {
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>
